export default "__VITE_ASSET__BsmaloMy__"